import { defineStore } from "pinia";

import type { User } from "@/Modules/Models/Domain/User";
import { StateNamespace } from "@/Modules/App/Models/State/StateNamespace";

import getUserDataAH from "@/Modules/User/ActionHandlers/GetUserData";

export interface ProfessionalViewState {
  isLoading: boolean;
  professional?: User;
}

const baseState: ProfessionalViewState = {
  isLoading: false,
  professional: undefined,
};

export const useProfessionalViewStore = defineStore(StateNamespace.PROFESSIONAL_VIEW, {
  state: () => ({ ...baseState }),
  getters: {},
  actions: {
    async fetchProfessionalInfo(uuid: string): Promise<void> {
      this.isLoading = true;

      this.professional = await getUserDataAH(uuid);

      this.isLoading = false;
    },
  },
});

export type ProfessionalViewStore = ReturnType<typeof useProfessionalViewStore>;

export default useProfessionalViewStore;
